module.exports = {
    getReportPage: {
        url: '/report/page'
    },
    uploadFile: {
        url: '/imgs/upload',
        method: 'post',
        dataType: 'file'
    },
    insertReport: {
        url: '/report/insert',
        method: 'post'
    },
    getReport: {
        url: '/report/:id'
    }
};